<template>
  <user-login-wrapper>
    <el-card class="full-card" shadow="always">
      <template #header>
        <div v-if="detail != null">
          <jr-applicant-title
            titleName="境界立会ステータス入力"
            :applicantNumber="detail.applicant_number"
            :applicantTitle="detail.applicant_title"
          />
        </div>
      </template>
      <template #default>
        <double-scroll>
          <template #left>
            <boundary-info v-if="requestHeaderId" :requestHeaderId="requestHeaderId" @update:form="detail = $event" />
          </template>
          <template #right>
            <!-- フッター -->
            <div class="footer-wrapper">
              <div class="footer">
                <el-row class="double-scroll-padding">
                  <el-col :span="24" class="align-right">
                    <!-- ステータス入力決定ボタン -->
                    <boundary-status-edit-send
                      :BoundaryStatusForm="form"
                      :formRef="formRef"
                      :requestHeaderId="requestHeaderId"
                      :boundaryId="detail.boundary.boundary_id"
                      v-if="detail != null && requestHeaderId"
                    />
                  </el-col>
                </el-row>
              </div>
            </div>
            <el-form
              :model="form"
              :rules="boundaryStatusRule"
              ref="formRef"
              class="right-panels double-scroll-padding"
              v-if="form != null && requestHeaderId"
            >
              <!-- 境界立会ステータス入力-->
              <input-group-dark title="境界立会ステータス入力" class="preliminary_survey">
                <!-- 境界確認申請受付日 -->
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="境界確認申請受付日">
                    <el-row>
                      <el-col class="status-checkbox text-xs" :span="2">
                        <el-form-item
                          prop="boundary_confirm_applicant_receipt_date_checked"
                          class="boundary_confirm_applicant_receipt_date_checked"
                        >
                          <jr-checkbox v-model="form.boundary_confirm_applicant_receipt_date_checked">済</jr-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <form-item-disabled
                          prop="boundary_confirm_applicant_receipt_date"
                          class="boundary_confirm_applicant_receipt_date"
                          :disabled="!form.boundary_confirm_applicant_receipt_date_checked"
                        >
                          <jr-date-picker
                            v-model="form.boundary_confirm_applicant_receipt_date"
                            :disabled="!form.boundary_confirm_applicant_receipt_date_checked"
                          />
                        </form-item-disabled>
                      </el-col>
                    </el-row>
                  </el-descriptions-item>
                </el-descriptions>
                <!-- 調査開始日 -->
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="調査開始日">
                    <el-row>
                      <el-col class="status-checkbox text-xs" :span="2">
                        <el-form-item prop="research_start_date_checked" class="research_start_date_checked">
                          <jr-checkbox v-model="form.research_start_date_checked">済</jr-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <form-item-disabled
                          prop="research_start_date"
                          class="research_start_date"
                          :disabled="!form.research_start_date_checked"
                        >
                          <jr-date-picker
                            v-model="form.research_start_date"
                            :disabled="!form.research_start_date_checked"
                          />
                        </form-item-disabled>
                      </el-col>
                    </el-row>
                  </el-descriptions-item>
                </el-descriptions>
                <!-- 境界確認書受付日 -->
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="境界確認書受付日">
                    <el-row>
                      <el-col class="status-checkbox text-xs" :span="2">
                        <el-form-item
                          prop="boundary_confirm_receipt_date_checked"
                          class="boundary_confirm_receipt_date_checked"
                        >
                          <jr-checkbox v-model="form.boundary_confirm_receipt_date_checked">済</jr-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <form-item-disabled
                          prop="boundary_confirm_receipt_date"
                          class="boundary_confirm_receipt_date"
                          :disabled="!form.boundary_confirm_receipt_date_checked"
                        >
                          <jr-date-picker
                            v-model="form.boundary_confirm_receipt_date"
                            :disabled="!form.boundary_confirm_receipt_date_checked"
                          />
                        </form-item-disabled>
                      </el-col>
                    </el-row>
                  </el-descriptions-item>
                </el-descriptions>
                <!-- 発送日 -->
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="発送日">
                    <el-row>
                      <el-col class="status-checkbox text-xs" :span="2">
                        <el-form-item prop="send_date_checked" class="send_date_checked">
                          <jr-checkbox v-model="form.send_date_checked">済</jr-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <form-item-disabled prop="send_date" class="send_date" :disabled="!form.send_date_checked">
                          <jr-date-picker v-model="form.send_date" :disabled="!form.send_date_checked" />
                        </form-item-disabled>
                      </el-col>
                    </el-row>
                  </el-descriptions-item>
                </el-descriptions>
                <!-- 用地管理システム登録日 -->
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="用地管理システム登録日">
                    <el-row>
                      <el-col class="status-checkbox text-xs" :span="2">
                        <el-form-item
                          prop="land_system_register_date_checked"
                          class="land_system_register_date_checked"
                        >
                          <jr-checkbox v-model="form.land_system_register_date_checked">済</jr-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <form-item-disabled
                          prop="land_system_register_date"
                          class="land_system_register_date"
                          :disabled="!form.land_system_register_date_checked"
                        >
                          <jr-date-picker
                            v-model="form.land_system_register_date"
                            :disabled="!form.land_system_register_date_checked"
                          />
                        </form-item-disabled>
                      </el-col>
                    </el-row>
                  </el-descriptions-item>
                </el-descriptions>
              </input-group-dark>
            </el-form>
          </template>
        </double-scroll>
      </template>
    </el-card>
  </user-login-wrapper>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watch } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'
import BoundaryInfo from '@/components/layout/BoundaryInfo.vue'
import JrApplicantTitle from '@/components/jr-parts/JrApplicantTitle.vue'
import InputGroupDark from '@/components/layout/InputGroupDark.vue'
import JrDatePicker from '@/components/jr-parts/JrDatePicker.vue'
import JrCheckbox from '@/components/jr-parts/JrCheckbox.vue'
import BoundaryStatusEditSend from '@/components/actions/BoundaryStatusEditSend.vue'
import { ElForm } from 'element-plus'
import { boundaryStatusRule } from '@/constants/rules'
import FormItemDisabled from '@/components/layout/FormItemDisabled.vue'
import { dateToString } from '@/services/date'
import Logger from '@/services/logger'

import { useRoute, useRouter } from 'vue-router'
import { BoundaryStatusForm, RequestHeaderBoundaryDetailForm } from '@/types/forms'

/**
 * 境界立会申請件名詳細
 */
export default defineComponent({
  name: 'BoundaryDetail',
  components: {
    DoubleScroll,
    UserLoginWrapper,
    BoundaryInfo,
    JrApplicantTitle,
    InputGroupDark,
    JrCheckbox,
    JrDatePicker,
    BoundaryStatusEditSend,
    FormItemDisabled,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    // 初期値を設定
    const form = ref<BoundaryStatusForm | null>(null)
    const formRef = ref<InstanceType<typeof ElForm>>()
    const requestHeaderId = computed(() => {
      return Number(route.params.request_header_id)
    })
    const detail = ref<RequestHeaderBoundaryDetailForm | null>(null)

    // 申請基本IDチェック
    if (Number.isNaN(requestHeaderId.value)) {
      Logger.info('申請基本IDが正しくない')
      router.push({ name: 'NotFound' })
    }

    watch(
      detail,
      () => {
        if (detail.value && !form.value) {
          form.value = {
            // 境界確認申請受付日
            boundary_confirm_applicant_receipt_date: detail.value.boundary.boundary_confirm_applicant_receipt_date,
            // 調査開始日
            research_start_date: detail.value.boundary.research_start_date,
            // 境界確認書受付日
            boundary_confirm_receipt_date: detail.value.boundary.boundary_confirm_receipt_date,
            // 発送日
            send_date: detail.value.boundary.send_date,
            // 用地管理システム登録日
            land_system_register_date: detail.value.boundary.land_system_register_date,
            // チェックボタン
            boundary_confirm_applicant_receipt_date_checked: detail.value.boundary
              .boundary_confirm_applicant_receipt_date
              ? true
              : false,
            research_start_date_checked: detail.value.boundary.research_start_date ? true : false,
            boundary_confirm_receipt_date_checked: detail.value.boundary.boundary_confirm_receipt_date ? true : false,
            send_date_checked: detail.value.boundary.send_date ? true : false,
            land_system_register_date_checked: detail.value.boundary.land_system_register_date ? true : false,
          }
        }
      },
      { deep: true }
    )

    // *****境界確認申請受付日*****
    watch(
      () => form.value?.boundary_confirm_applicant_receipt_date_checked,
      () => {
        if (form.value) {
          if (
            form.value.boundary_confirm_applicant_receipt_date_checked &&
            !form.value.boundary_confirm_applicant_receipt_date
          ) {
            form.value.boundary_confirm_applicant_receipt_date = dateToString(new Date())
          }
        }
      },
      { deep: true }
    )

    // *****調査開始日*****
    watch(
      () => form.value?.research_start_date_checked,
      () => {
        if (form.value) {
          if (form.value.research_start_date_checked && !form.value.research_start_date) {
            form.value.research_start_date = dateToString(new Date())
          }
        }
      },
      { deep: true }
    )

    // *****境界確認書受付日*****
    watch(
      () => form.value?.boundary_confirm_receipt_date_checked,
      () => {
        if (form.value) {
          if (form.value.boundary_confirm_receipt_date_checked && !form.value.boundary_confirm_receipt_date) {
            form.value.boundary_confirm_receipt_date = dateToString(new Date())
          }
        }
      },
      { deep: true }
    )

    // *****発送日*****
    watch(
      () => form.value?.send_date_checked,
      () => {
        if (form.value) {
          if (form.value.send_date_checked && !form.value.send_date) {
            form.value.send_date = dateToString(new Date())
          }
        }
      },
      { deep: true }
    )

    // *****用地管理システム登録日*****
    watch(
      () => form.value?.land_system_register_date_checked,
      () => {
        if (form.value) {
          if (form.value.land_system_register_date_checked && !form.value.land_system_register_date) {
            form.value.land_system_register_date = dateToString(new Date())
          }
        }
      },
      { deep: true }
    )

    return {
      requestHeaderId,
      detail,
      form,
      formRef,
      boundaryStatusRule,
    }
  },
})
</script>

<style lang="scss" scoped>
.input-group-dark {
  margin-top: 8px;
  margin-bottom: 50px;
}

.right-panels {
  margin-top: -8px;
  margin-bottom: -8px;
}

.el-descriptions {
  ::v-deep(.el-descriptions__label) {
    width: 140px;
  }
}

.status-checkbox {
  margin: 0px 15px 0px 10px;
}
</style>
